import type { Offer } from '@fourthwall/services/dist/models/offer'

export const hasAnyVariantZeroCost = (variants: Offer.Variant[]) => {
  return variants.some((variant) => variant.cost?.value === 0)
}
